import WidgetModule from "@eisinc/Overrides/Widgets/BrandDetails/BrandDetailsContent";

export * from "@eisinc/Overrides/Widgets/BrandDetails/BrandDetailsContent";

export default WidgetModule;
